{
    "InsightsDashboard_Title": "Connaissances",
    "InsightsDashboard_BusinessFilter": "Filtre d'entreprise",
    "InsightsDashboard_AllPartitions": "Tous les sites",
    "InsightsDashboard_CallsReceived": "Appels reçus",
    "InsightsDashboard_MissedCalls": "Appels manqués",
    "InsightsDashboard_AverageAnswer": "Réponse moyenne",
    "InsightsDashboard_AverageAbandoned": "Moyenne abandonnée",
    "InsightsDashboard_LongestWait": "La plus longue attente",
    "InsightsDashboard_VsLastWeekCurrently": "Actuellement",
    "InsightsDashboard_PercentVsLastWeek": "**{}%** par rapport à la semaine dernière",
    "InsightsDashboard_VsLastWeek": "**{}** vs la semaine dernière",
    "InsightsDashboard_BusiestDay": "Journée la plus chargée",
    "InsightsDashboard_PeakCalls": "Appels de pointe",
    "InsightsDashboard_MostCalledInboundNumber": "Numéro entrant le plus appelé",
    "InsightsDashboard_MostAnsweredCalls": "Appels les plus répondus",
    "InsightDashboard_CalledNumber": "Numéro appelé",
    "InsightsDashboard_User": "Utilisateur",
    "InsightsDashboard_SecondsDisplay": "{}s",
    "InsightsDashboard_Tooltip_TimeLabel": "Heure : {}:00",
    "InsightsDashboard_Tooltip_DayLabel": "Jour: {}",
    "InsightsDashboard_Tooltip_CallsLabel": "Nombre d'appels : {}",
    "InsightsDashboard_Tooltip_Stats_0": "Appels reçus : {}",
    "InsightsDashboard_Tooltip_Stats_1": "Appels manqués : {}",
    "InsightsDashboard_Tooltip_Stats_2": "Réponse moyenne : {}",
    "InsightsDashboard_Tooltip_Stats_3": "Moyenne abandonnée : {}",
    "InsightsDashboard_Tooltip_Stats_4": "Attente la plus longue : {}",
    "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Semaine commençant le : {}",
    "InsightsDashboard_OfLast30Days": "des 30 derniers jours",
    "InsightsDashboard_OverLast30Days": "Au cours des 30 derniers jours",
    "InsightsDashboard_OverLast7Days": "Au cours des 7 derniers jours",
    "InsightsDashboard_ThisWeek": "Cette semaine",
    "InsightsDashboard_LastWeek": "La semaine dernière",
    "InsightsDashboard_PrevWeek": "Semaine précédente",
    "InsightsDashboard_ErrorState_Message": "Nous sommes désolés, il y a eu un problème. \n Veuillez actualiser votre navigateur. \n \n {}",
    "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "Aucun serveur de téléphonie ou partition sélectionné",
    "InsightsDashboard_Tour_Step_1": "Ici vous sélectionnez votre entreprise et votre site",
    "InsightsDashboard_Tour_Step_2": "Consultez les indicateurs de point de contact de votre entreprise au cours des 30 derniers jours : \n ##?##Jours les plus chargés, vous permettant de mieux planifier les ressources####Périodes les plus chargées, soyez prêt avec une couverture aux heures de pointe pour ne pas manquer d'appels####?",
    "InsightsDashboard_Tour_Step_3": "Indicateurs clés de performance des appels au cours des 30 derniers jours : \n ##?##Nombre total d'appels reçus par votre entreprise####Appels manqués####Temps moyens de réponse et d'abandon####Temps d'attente le plus long pour un appel####? \n Cliquez sur les indicateurs pour obtenir une comparaison et des tendances hebdomadaires.",
    "InsightsDashboard_Tour_Step_4": "Identifiez les numéros entrants DDI les plus fréquemment utilisés au cours des 7 derniers jours, ainsi que les utilisateurs qui répondent le plus aux appels. Le top 10 s'affichera.",
    "InsightsDashboard_Tour_Step_5": "Cliquez ici pour ouvrir le portail de signalement",
    "InsightsDashboard_Tour_Step_6": "Cliquez ici pour ouvrir le portail de signalement",
    "NAME": "InsightsDashboardLanguage"
}